"use client";

import { NotFound } from "@/components/blocks/NotFound";

export default function ErrorPage() {
  return <NotFound />;
}
